interface BillingConfirmationLocation {
  href: string;
}

export function navigateToBillingConfirmationUrl({
  confirmationUrl,
  location = window.location,
}: {
  confirmationUrl: string | undefined;
  location?: BillingConfirmationLocation;
}) {
  if (confirmationUrl) {
    location.href = confirmationUrl;
  }
}
